import type { FilterState, Gender, LocationKind } from "../types";

export const SUPPORTED_RANKING_TYPES = ["distance-challenge"] as const;
export const S3_BASE_URL =
  "https://tatta-prod-main.s3-ap-northeast-1.amazonaws.com/public";
export const DEFAULT_EVENT_URL =
  "https://tatta.runnet.jp/rankings/199177/distance-challenge";

export const AGE_GROUPS = [
  "19 歲以下",
  "20–29 歲",
  "30–39 歲",
  "40–49 歲",
  "50–59 歲",
  "60–69 歲",
  "70–79 歲",
  "80 歲以上",
  "未知",
] as const;

export const GENDER_OPTIONS: Array<{ value: Gender; label: string }> = [
  { value: "male", label: "男性" },
  { value: "female", label: "女性" },
  { value: "other", label: "其他" },
  { value: "unknown", label: "未知／未公開" },
];

export const LOCATION_OPTIONS: Array<{ value: LocationKind; label: string }> = [
  { value: "japan", label: "日本" },
  { value: "overseas", label: "海外" },
  { value: "unknown", label: "未知／未公開" },
];

export const PREFECTURES = [
  "北海道",
  "青森縣",
  "岩手縣",
  "宮城縣",
  "秋田縣",
  "山形縣",
  "福島縣",
  "茨城縣",
  "栃木縣",
  "群馬縣",
  "埼玉縣",
  "千葉縣",
  "東京都",
  "神奈川縣",
  "新潟縣",
  "富山縣",
  "石川縣",
  "福井縣",
  "山梨縣",
  "長野縣",
  "岐阜縣",
  "靜岡縣",
  "愛知縣",
  "三重縣",
  "滋賀縣",
  "京都府",
  "大阪府",
  "兵庫縣",
  "奈良縣",
  "和歌山縣",
  "鳥取縣",
  "島根縣",
  "岡山縣",
  "廣島縣",
  "山口縣",
  "德島縣",
  "香川縣",
  "愛媛縣",
  "高知縣",
  "福岡縣",
  "佐賀縣",
  "長崎縣",
  "熊本縣",
  "大分縣",
  "宮崎縣",
  "鹿兒島縣",
  "沖繩縣",
] as const;

export const EMPTY_FILTERS: FilterState = {
  query: "",
  genders: [],
  ageGroups: [],
  locations: [],
  prefectures: [],
  ageMin: "",
  ageMax: "",
  timeMinHours: "",
  timeMaxHours: "",
  activityMin: "",
  activityMax: "",
  dateFrom: "",
  dateTo: "",
};

export const CHART_COLORS = [
  "#44d7b6",
  "#ffcf5c",
  "#ff718b",
  "#8ea9ff",
  "#a6df78",
  "#d59cff",
  "#ff9e64",
  "#6ccff6",
];
